import { NoticeResponse } from '@@types/Api/Channel';
import { NoticeListResponse } from '@@types/Api/Notice';
import { CHANNEL_ID, LOG_ID } from '@@types/common';

import { URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';

class NoticeApi {
  constructor(private api: Api2) {}

  fetchChannelPostNotice = (channelId: CHANNEL_ID): Promise<NoticeResponse> => {
    return this.api.contentsRequester.cancelGet(`${URLS.API}/channels/${channelId}/notices/top`, channelId);
  };

  deletePostNotice = (channelId: CHANNEL_ID): Promise<''> => {
    return this.api.contentsRequester.delete(`${URLS.API}/channels/${channelId}/notices/top`);
  };

  fetchChannelNotices = (channelId: CHANNEL_ID): Promise<NoticeListResponse> => {
    return this.api.contentsRequester.cancelGet(`${URLS.API}/channels/${channelId}/notices`, channelId);
  };

  postChannelNotice = (channelId: CHANNEL_ID, logId: LOG_ID): Promise<string> => {
    return this.api.contentsRequester.post(`${URLS.API}/channels/${channelId}/notices`, {
      logId,
    });
  };
}

export default NoticeApi;
